module.exports = __webpack_public_path__ + "img/2.84c1190e.jpg";